/*------------------ platform Function ------------------------*/
/**
 * @description: 检测当前运行环境是否为 macOS
 * @returns {boolean} 如果是 macOS 返回 true，否则返回 false
 */
export function isMacOS() {

    return navigator.platform.indexOf('Mac') === 0;
}

/**
 * @description: 检测当前运行环境是否为 Windows
 * @returns {boolean} 如果是 Windows 返回 true，否则返回 false
 */
export function isWindows() {

    return navigator.platform.indexOf('Win') === 0;
}
/**
 * @description: 检测当前运行环境是否为 Linux
 * @returns {boolean} 如果是 Linux 返回 true，否则返回 false
 */
export function isLinux() { return false; }